// Development uses the local proxy; production can select its API at build time.
const apiOrigin = (
  process.env.REACT_APP_API_URL ??
  (process.env.NODE_ENV === "development" ? "" : "https://apis.nuhman.com")
).replace(/\/+$/, "");
export const API_URL = `${apiOrigin}/`;
export const AUTH_API_URL = (
  process.env.REACT_APP_AUTH_API_URL ?? apiOrigin
).replace(/\/+$/, "");
